import { useEffect, useState } from 'react';

import { UserAttributes } from '../interfaces';
import { AuthService } from '../services/auth.service';

export const useCognitoUser = (): UserAttributes | null => {
  const [user, setUser] = useState<UserAttributes | null>(null);

  useEffect(() => {
    try {
      AuthService.getUserAttributes().then(setUser);
    } catch (e) {
      console.warn(e);
    }
  }, []);

  return user;
};
